export default new (class {
  constructor() {
    this.data = {
      breakpoint: false,
    };

    this.selectors = {
      trigger_target: '[data-trigger-target]',
      dropdown_trigger_target: '.c-main-nav-mobile-item__chevron',
    };

    this.classes = {
      active: 'active',
      hidden: 'hidden',
      body_fixed_class: 'menu-open',
    };

    window.addEventListener('resize', () => {
      this.updateBreakpointStatus();
    });
  }

  init() {
    this.updateBreakpointStatus();
    this.getDOM();
    this.bindNavToggleEvents();
    this.bindDropdownToggleEvents();
    this.closeOnSearchOpen();
  }

  updateBreakpointStatus() {
    this.data.breakpoint = window.matchMedia('(min-width: 1024px)');
  }

  getDOM() {
    this.DOM = {
      body: document.body,
      triggers: document.querySelectorAll(this.selectors.trigger_target),
      dropdownTriggers: document.querySelectorAll(
        this.selectors.dropdown_trigger_target,
      ),
    };
  }

  bindNavToggleEvents() {
    Array.from(this.DOM.triggers).forEach((trigger) => {
      trigger.addEventListener(
        'click',
        this.triggerClickHandler.bind(this, trigger),
      );
    });
  }

  bindDropdownToggleEvents() {
    Array.from(this.DOM.dropdownTriggers).forEach((trigger) => {
      trigger.addEventListener(
        'click',
        this.handleDropdownClick.bind(this, trigger),
      );
    });
  }

  triggerClickHandler(trigger) {
    if (this.data.breakpoint.matches) {
      return;
    }
    const targetSelector = trigger.dataset.triggerTarget;
    const target = document.querySelector(`[data-nav="${targetSelector}"]`);
    this.toggleBodyFixed();
    this.toggleNav(trigger, target);
    const event = new Event('onCloseSearch');
    document.dispatchEvent(event);
  }

  toggleBodyFixed() {
    if (this.DOM.body.classList.contains(this.classes.body_fixed_class)) {
      this.DOM.body.classList.remove(this.classes.body_fixed_class);
    } else {
      this.DOM.body.classList.add(this.classes.body_fixed_class);
    }
  }

  toggleNav(trigger, target) {
    trigger.classList.toggle(this.classes.active);
    target.classList.remove(this.classes.hidden);
    target.classList.toggle(this.classes.active);
  }

  handleDropdownClick(trigger) {
    if (this.data.breakpoint.matches) {
      return;
    }
    // event.preventDefault();
    trigger.closest('li').classList.toggle(this.classes.active);
  }

  closeOnSearchOpen() {
    document.addEventListener('onCloseMenu', () => {
      if (this.data.breakpoint.matches) {
        return;
      }
      this.DOM.body.classList.remove(this.classes.body_fixed_class);
      Array.from(this.DOM.triggers).forEach((trigger) => {
        const targetSelector = trigger.dataset.triggerTarget;
        const target = document.querySelector(`[data-nav="${targetSelector}"]`);
        trigger.classList.remove(this.classes.active);
        target.classList.add(this.classes.hidden);
        target.classList.remove(this.classes.active);
      });
    });
  }
})();
